'use strict';
require('../user/UserService.js');

function UserActivateCtrl(
  $scope,
  UserService,
  $translate,
  $stateParams,
  $state,
  $window,
  growl) {
  //Kill session
  delete $window.localStorage.token;
  delete $window.localStorage.userId;
  delete $window.localStorage.language;
  $scope.companyName = decodeURIComponent($stateParams.company);
  $scope.user = {};
  $scope.user.email = decodeURIComponent($stateParams.email);

  $scope.availableLanguages = [
    {value: "en", label: "English"},
    {value: "se", label: "Svenska"}
  ];

  $scope.user.language = 'se';
  $translate.use($scope.user.language);
  $scope.switchLanguage = function(langKey) {
    $translate.use(langKey);
  };

  $scope.createUser = function(){
    UserService.save({companyId: $stateParams.companyId, code: decodeURIComponent($stateParams.code)}, $scope.user)
      .$promise
      .then(function(){
        growl.addSuccessMessage('signup.success');
        window.location.href = '/login';
      }, function(){
        growl.addErrorMessage('signup.failure');
      });
  };
}

angular.module('dokiv')
  .controller('UserActivateCtrl', [
    '$scope',
    'UserService',
    '$translate',
    '$stateParams',
    '$state',
    '$window',
    'growl', UserActivateCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/auth/UserActivateCtrl.js
// module id = 278
// module chunks = 0